import React from 'react'

const PrivacyPolicy = () => {
  return (
    <section className="section-one">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
                <p>
                Welcome to our homemade products e-commerce platform. At Village Zone, we are dedicated to protecting your privacy and safeguarding your personal information.
                This Privacy Policy outlines how we collect, use, and protect your information when you use our platform to purchase homemade products.
                </p>
                <p>
                By using our platform, you consent to the collection and use of your personal information as described in this Privacy Policy.
                If you do not agree with the terms of this policy, please refrain from using our platform.
                </p>

                <p><strong>Information Collection and Use</strong></p>
                <p>When you use our e-commerce platform to browse, purchase, or interact with homemade products, we may collect the following types of information:</p>
                <ol>
                <li>Personal Information: This includes your name, email address, phone number, shipping address, and billing information.</li>
                <li>Account Information: If you create an account on our platform, we may collect your username, password, and other account details.</li>
                <li>Transaction Information: We collect information about your purchases, including the products you buy, payment details, and shipping information.</li>
                <li>Communication: We may collect information from your communications with us, such as inquiries, feedback, or customer support interactions.</li>
                <li>Device Information: We may collect information about the device you use to access our platform, including IP address, browser type, and operating system.</li>
                </ol>

                <p><strong>How We Use Your Information:</strong></p>
                <p>We use the information we collect for the following purposes:</p>
                <ol>
                <li>Order Fulfillment: To process and fulfill your orders, including shipping products to your designated address.</li>
                <li>Account Management: To manage your account, including authentication, account recovery, and personalized experiences.</li>
                <li>Customer Support: To provide customer support and respond to inquiries, feedback, or complaints.</li>
                <li>Marketing Communications: With your consent, to send you promotional emails, newsletters, or other marketing communications about products, offers, or events.</li>
                <li>Analytics and Improvements: To analyze usage trends, monitor the performance of our platform, and make improvements to our products and services.</li>
                </ol>

                <p><strong>Data Security:</strong></p>
                <p>
                We take the security of your personal information seriously and have implemented appropriate technical and organizational measures
                to protect it from unauthorized access, disclosure, alteration, or destruction.
                </p>

                <p><strong>Disclosure of Information:</strong></p>
                <p>
                We may share your information with third-party service providers, vendors, or partners who assist us in providing our services
                or conducting our business operations. We may also disclose your information when required by law or to protect our legal rights.
                </p>

                <p><strong>Your Rights:</strong></p>
                <p>
                You have the right to access, update, or delete your personal information stored on our platform. You may also opt-out of receiving marketing
                communications from us at any time by following the instructions provided in the communication.
                </p>

                <p><strong>Changes to this Privacy Policy:</strong></p>
                <p>
                We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page with an updated effective date.
                We encourage you to review this Privacy Policy periodically for any updates.
                </p>

                <p><strong>Contact Us:</strong></p>
                <p>
                If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at info@rastelx.com.
                </p>

                <p>
                By using our e-commerce platform, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy.
                </p>

                <p>This policy is effective as of 2024-05-10</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PrivacyPolicy